module.exports = __webpack_public_path__ + "img/wanted2.85304210.png";